import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Paper } from '@clds/paper';

export interface WithBackgroundProps {
  children: ReactNode;
  withBackground?: boolean;
  id?: string;
}

export const SdkCodeSnippetsLayout = styled<FC<WithBackgroundProps>>(({ withBackground, children, id, ...rest }) => (
  <div id={id} {...rest}>
    {withBackground ? (
      <Paper isPadded depth="none">
        {children}
      </Paper>
    ) : (
      children
    )}
  </div>
))``;
